export namespace SearchSecurityConstants {
    export const SearchSecurityNameSpaceId: string = "ca535e7e-67ce-457f-93fe-6e53aa4e4160";
    export const SearchSecurityReadPermission: number = 1;
    export const SearchSecurityPermissionTelemetry: string = "SearchSecurityPermissionTelemetry";
    export const SearchEvaluatePermissionsFeatureFlag: string = "WebAccess.Search.EvaluatePermissions";
    export const SearchEnableAssignedToFeatureFlag: string = "WebAccess.Search.WorkItem.EnableAssignedToFilterForPublicUsers";
}

export namespace TelemetryConstants {
    export const UrlParameterKeyTrackingData = "tracking_data";
}

export namespace ActionIds {
    export const Download: string = "download";
    export const FullScreen: string = "fullScreen";
}

export namespace PivotTabActionIds {
    export const Contents: string = "contents";
    export const History: string = "history";
    export const Compare: string = "compare";
    export const Blame: string = "blame";
    export const Preview: string = "preview";
}

export namespace HitsNavigationActionIds {
    export const NextHitNavigation: string = "nextHitNavigation";
    export const PrevHitNavigation: string = "prevHitNavigation";
}

export namespace CompareViewActionIds {
    export const NextDiffNavigation: string = "nextDiffNavigation";
    export const PrevDiffNavigation: string = "prevDiffNavigation";
    export const ToggleInlineDiff: string = "toggleInlineDiff";
}

export namespace KeyCodes {
    export const F8: number = 119;
}

export namespace ErrorTypeKeys {
    export const GitFilePathsMaxCountExceededException: string = "GitFilePathsMaxCountExceededException";
}

export const FileNameHitKey: string = "fileName";
export const ContentHitKey: string = "content";
export const HitHightedLineCssClass: string = "search-hit-highlighted-line";
export const SelectedHit: string = "search-selected-hit";
export const OrgSearchUrlTypeRepository: string = "ms.vss-orgsearch.repository-search-provider";
export const OrgSearchUrlTypeProjects: string = "ms.vss-orgsearch.projects-search-provider";
export const OrgSearchUrlTypeWiki: string = "ms.vss-orgsearch.wiki-search-provider";
export const NewBrandingFeatureFlag = "VisualStudio.Services.WebPlatform.UseNewBranding";

export const GitRootPath: string = "/";
export const TfvcRootPath: string = "$/";